import { Navigate, useParams } from "react-router-dom";
import { getLegacyProduct } from "../data/legacyProducts";
export const LegacyProductRedirect = () => {
  const { slug } = useParams();
  const t = getLegacyProduct(slug);
  if (t) {
    return <Navigate to={t.path} replace={true} />;
  } else {
    return <Navigate to="/products/thor-v2" replace={true} />;
  }
};
